import { v4 as uuid } from 'uuid';

export enum ProcessQuestionTypeModel {
  MultiChoice = 0,
  FreeText = 1,
  SingleChoice = 2,
  YesNo = 3,
  OneWayVideo = 4,
}

export class ProcessQuestionModel {
  id: number;
  uuid: string;
  debug: string;
  question_text: string;
  type: ProcessQuestionTypeModel;
  reject_on_failure: boolean;
  is_required: boolean;
  alternatives: Array<ProcessAltQuestionModel>;
}

export class ProcessAltQuestionModel {
  id: number;
  answer_text: string;
  is_correct: boolean;
}
